import { Component, OnInit, OnDestroy, HostListener, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Angulartics2 } from 'angulartics2';
import * as $ from 'jquery';
import 'hammerjs';
import { PrivacyDialogComponent } from '../privacy-dialog/privacy-dialog.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})

export class FooterComponent implements OnInit, OnDestroy {

  constructor(public angulartics2: Angulartics2,
              public router: Router,
              private dialog: MatDialog) {

  }

  ngOnInit() {

  }

  ngOnDestroy() {

  }

  scrollToTop() {
    $('html, body').animate({scrollTop: 0}, 'medium');
  }

  scrollAboutTitle() {
    try {
      $('html, body').scrollTop(0);
      $('#under-bar').css({'opacity': 1});
      $('#under-bar').animate({'margin-left': '36px'});
      if (window.innerWidth <= 1194) {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.add('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.remove('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.remove('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.remove('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.remove('opac');
      }
    } catch (e) {
      // console.log(e);
    }
  }

  scrollAboutMission() {
    try {
      $('html, body').animate({scrollTop: $('#mission').offset().top - 80}, 'medium');
      $('#under-bar').css({'opacity': 1});
      $('#under-bar').animate({'margin-left': '36px'});
      if (window.innerWidth <= 1194) {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.add('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.remove('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.remove('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.remove('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.remove('opac');
      }
    } catch (e) {
      // console.log(e);
    }
  }

  scrollBrands() {
    $('html, body').animate({scrollTop: $('#mission').offset().top - 70}, 'medium');
    $('#under-bar').css({'opacity': 1});
    $('#under-bar').animate({'margin-left': '138px'});
    if (window.innerWidth <= 1194) {
      const mobileAbout = document.getElementById('mobile-about');
      mobileAbout.classList.remove('opac');
      const mobileBrands = document.getElementById('mobile-brands');
      mobileBrands.classList.add('opac');
      const mobileTeam = document.getElementById('mobile-team');
      mobileTeam.classList.remove('opac');
      const mobileInvestors = document.getElementById('mobile-investors');
      mobileInvestors.classList.remove('opac');
      const mobileContact = document.getElementById('mobile-contact');
      mobileContact.classList.remove('opac');
    }
  }

  scrollTeam() {
    $('html, body').scrollTop(0);
    $('#under-bar').css({'opacity': 1});
    $('#under-bar').animate({'margin-left': '235px'});
    if (window.innerWidth <= 1194) {
      const mobileAbout = document.getElementById('mobile-about');
      mobileAbout.classList.remove('opac');
      const mobileBrands = document.getElementById('mobile-brands');
      mobileBrands.classList.remove('opac');
      const mobileTeam = document.getElementById('mobile-team');
      mobileTeam.classList.add('opac');
      const mobileInvestors = document.getElementById('mobile-investors');
      mobileInvestors.classList.remove('opac');
      const mobileContact = document.getElementById('mobile-contact');
      mobileContact.classList.remove('opac');
    }
  }

  scrollInvestorsStock() {
    try {
      $('html, body').animate({scrollTop: $('#stock').offset().top - 80}, {duration: 'medium'});
      if (window.innerWidth <= 1194) {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.remove('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.remove('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.remove('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.add('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.remove('opac');
      }
    } catch (e) {
      // console.log(e);
    }
  }

  scrollInvestorsFinancials() {
    try {
      $('html, body').animate({scrollTop: $('#financials').offset().top - 180}, 'medium');
      if (window.innerWidth <= 1194) {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.remove('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.remove('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.remove('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.add('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.remove('opac');
      }
    } catch (e) {
      // console.log(e);
    }
  }

  scrollInvestorsCorporate() {
    try {
      $('html, body').animate({scrollTop: $('#corporate').offset().top - 120}, 'medium');
      if (window.innerWidth <= 1194) {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.remove('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.remove('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.remove('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.add('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.remove('opac');
      }
    } catch (e) {
      // console.log(e);
    }
  }

  scrollInvestorsPress() {
    try {
      $('html, body').animate({scrollTop: $('#press').offset().top - 80}, 'medium');
      if (window.innerWidth <= 1194) {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.remove('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.remove('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.remove('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.add('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.remove('opac');
      }
    } catch (e) {
      // console.log(e);
    }
  }

  scrollInvestorsPresentations() {
    try {
      $('html, body').animate({scrollTop: $('#presentations').offset().top - 80}, {duration: 'medium'});
      if (window.innerWidth <= 1194) {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.remove('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.remove('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.remove('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.add('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.remove('opac');
      }
    } catch (e) {
      // console.log(e);
    }
  }

  openPrivacyDialog() {
    try {
      $('.nav-item').addClass('hide-item');
      $('#privacy').addClass('show-item');
      $('.header').addClass('is-white');
      $('.button-container').removeClass('hide-item');
      $('#nav-bar').css('display', 'block !important');
      $('html, body').scrollTop(0);
    } catch (e) {
      console.log(e);
    }
  }

}
